var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0138 60.989C29.0138 63.2077 30.8124 65.0063 33.0311 65.0063C35.2498 65.0063 37.0484 63.2077 37.0484 60.989V36.8851H61.1523C63.371 36.8851 65.1696 35.0865 65.1696 32.8678C65.1696 30.6491 63.371 28.8505 61.1523 28.8505H37.0484V4.74656C37.0484 2.52786 35.2498 0.729248 33.0311 0.729248C30.8124 0.729248 29.0138 2.52786 29.0138 4.74656L29.0138 28.8505H4.90989C2.69119 28.8505 0.892578 30.6491 0.892578 32.8678C0.892578 35.0865 2.69119 36.8851 4.90989 36.8851H29.0138L29.0138 60.989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusNew);
export default __webpack_public_path__ + "static/media/plus-new.42692db2f65399547a4b6549db648f8b.svg";
export { ForwardRef as ReactComponent };